import React from 'react'
import Profile2FAGAComponent from '../../components/Profile/2faGA'

export default function Profile2FAGA () {
  return (
    <Profile2FAGAComponent/>
  )
}
